import { getEnvironmentConfig } from '../../services/config/restClientEnvConfig.js';
import {
  getCurrentFisicalYear,
  setCookie,
  getCookie,
  setSessionStorage,
  getImageSrc,
  getSessionStorage
} from './CommonUtils';
import store from '../../redux/reducers/store';

import taxNec120 from '../../../assets/images/IM/Tax Forms/tax_99_120_nec.png';
import OptimizedTaxNec120 from '../../../assets/images/IM/Tax Forms/tax_99_120_necOp.webp';
import taxMisc120 from '../../../assets/images/IM/Tax Forms/tax_99_120.png';
import OptimizedTaxMisc120 from '../../../assets/images/IM/Tax Forms/tax_99_120Op.webp';
import w2k120 from '../../../assets/images/IM/Tax Forms/tax_w2k_120.png';
import OptimizedW2k120 from '../../../assets/images/IM/Tax Forms/tax_w2k_120.webp';
import taxw3120 from '../../../assets/images/IM/Tax Forms/tax_w3_120.png';
import OptimizedTaxw3120 from '../../../assets/images/IM/Tax Forms/tax_w3_120.webp';
import tax96120 from '../../../assets/images/IM/Tax Forms/tax_96_120.png';
import OptimizedTax98120 from '../../../assets/images/IM/Tax Forms/tax_96_120.webp';

const getSKUTreatment = (baseSKU) => {
  // Image and sub title tretment for the cart
  const SKU = baseSKU.split('-');
  const treatment = {};
  if (SKU.length > 1) {
    switch (SKU[0]) {
      case '2778':
        treatment.img = '/fsg_repository/Tax/Tax_w2B_278_thumb.png';
        treatment.desc = 'For Online Payroll';
        return treatment;
      case '278':
        treatment.img = '/fsg_repository/Tax/Tax_w2B_278_thumb.png';
        treatment.desc = 'For QuickBooks Desktop, Assisted Payroll';
        return treatment;
      case '276':
        treatment.img = '/fsg_repository/tax/Tax_w2B_277_Thumb.png';
        treatment.desc = 'For QuickBooks Desktop, Standard or Enhanced Payroll';
        return treatment;
      case '2766':
        treatment.img = '/fsg_repository/tax/Tax_w2B_277_Thumb.png';
        treatment.desc = 'For QuickBooks Desktop, Standard or Enhanced Payroll';
        return treatment;
      case '277':
        treatment.img = '/fsg_repository/tax/Tax_w2B_277_Thumb.png';
        treatment.desc = 'For QuickBooks Desktop, Standard or Enhanced Payroll';
        return treatment;
      case '2777':
        treatment.img = '/fsg_repository/Tax/Tax_w2B_278_thumb.png';
        treatment.desc = 'For QuickBooks Online';
        return treatment;
      default:
        break;
    }
  }
};

const getCustomAttribute = (product, attr) => {
  let colorValue;
  let attr1 = attr;
  if (attr === 'Accent') {
    attr1 = 'Border';
  }
  for (let i = 0; i < product.CustomAttributes.length; i++) {
    if (product.CustomAttributes[i].Type === attr || product.CustomAttributes[i].Type === attr1)
      colorValue = product.CustomAttributes[i].Name;
  }
  return colorValue;
};

export const setImageSrcUrl = (productData) => {
  let src = ''; // This is set, to know wts the prodttypeid inthe source, it will be overwritten if its passes condition
  let optSrc = null; 
  let ImageHeight = null;
  let ImageWidth = null;
  const product = productData;
  const SKUTreatment = getSKUTreatment(product.BaseSku);
  const { cdn } = getEnvironmentConfig();
  // let style = (!!this.imageStyle && this.imageStyle ==="ipdproductsell")?' style=width:45% ':' style=width:65% ';

  if (product) {
    if (product.CustomAttributes) {
      const attribute = product.CustomAttributes.find((attr) => {
        if (attr.Type === 'Style/Color') {
          return attr;
        }
        return false;
      });
      const prodArr = [
        'CHECK-01',
        'CHECK-02',
        'CHECK-09',
        'CHECK-11',
        'CHECK-12',
        'CHECK-14',
        'CHECK-16',
        'CHECK-17',
        'CHECK-03',
      ];
      if (prodArr.includes(product.ProductTypeID)) {
        const imgName = !!attribute && !!attribute.Name ? attribute.Name : 'default';
        // UBERPSG-9132 - Added if condition for image file extension
        if (product.ProductTypeID === 'CHECK-03') {
          src = `/UI/ipd/appcommon/images/${product.ProductTypeID}/${imgName}.jpg`;
        } else {
          src = `/UI/ipd/appcommon/images/${product.ProductTypeID}/${imgName}.png`;
        }
      }
    } // end of the product.CustomAttributes if condition
  } // end of the product if condition

  if (src === '') {
    switch (product.ProductTypeID) {
      case 'DEP-01':
        src = '/UI/ipd/appcommon/images/depositslips-productlist-manual.png';
        break;
      case 'DEP-02':
        src = '/UI/ipd/appcommon/images/depositslips-productlist-printable.png';
        break;
      case 'BUNDLE-01':
        src = '/UI/ipd/appcommon/images/VchCheckDVP_thumb.png';
        break;
      case 'BUNDLE-02':
        src = '/UI/ipd/appcommon/images/VoucherCheckBundle_Basic_thumb.png';
        break;
      case 'BUNDLE-03':
        src = '/UI/ipd/appcommon/images/StdCheckDVP_thumb.png';
        break;
      case 'BUNDLE-06':
        src = '/UI/ipd/appcommon/images/VoucherCheckBundle_SecurePlus_thumb.png';
        break;
      case 'BUNDLE-07':
        src = '/UI/ipd/appcommon/images/VoucherCheckBundle_SecurePremier_thumb.png';
        break;
      case 'TAX-01':
        src = w2k120;
        optSrc = OptimizedW2k120;
        ImageHeight = '140px';
        ImageWidth = '147px';
        break;
      case 'CHECK-01':
      case 'CHECK-02':
      case 'CHECK-09':
      case 'CHECK-11':
      case 'CHECK-12':
      case 'CHECK-14':
      case 'CHECK-16':
      case 'CHECK-17':
        src = `/UI/ipd/appcommon/images/${product.ProductTypeID.toLowerCase()}.png`;
        break;
      case 'STAMP-07':
      case 'STAMP-08':
      case 'STAMP-09':
      case 'STAMP-10':
      case 'STAMP-11':
      case 'STAMP-12':
      case 'STAMP-13':
      case 'STAMP-17':
      case 'STAMP-18':
        src = `/UI/ipd/appcommon/images/${product.ProductTypeID.toLowerCase()}.png`;
        // style = (!!this.imageStyle && this.imageStyle ==="ipdproductsell")?' style=width:25% ':' style=width:45% ';
        break;
      case 'BOX-01':
      case 'BOX-02':
      case 'BOX-03':
      case 'BOX-04':
      case 'BANHANG-01':
      case 'BANNER-01':
      case 'BANNER-02':
      case 'BANNER-03':
      case 'BANSTAND-01':
      case 'BIZCD-01':
      case 'BIZCD-02':
      case 'BROCH-01':
      case 'CAL-01':
      case 'CAL-02':
      case 'ENV-50':
      case 'ENV-51':
      case 'ENV-52':
      case 'ENV-53':
      case 'ENV-54':
      case 'FLYER-01':
      case 'HOLCD-01':
      case 'HOLCD-02':
      case 'HOLCD-03':
      case 'LETRHD-01':
      case 'LETRHD-02':
      case 'MAGNET-01':
      case 'MAGNET-02':
      case 'POSTCD-01':
      case 'POSTCD-02':
      case 'RACK-01':
      case 'RAL-01':
      case 'RAL-02':
      case 'SIGN-01':
      case 'SIGN-02':
      case 'STAMP-20':
      case 'STAMP-21':
      case 'STAND-01':
        src = '/UI/ipd/appcommon/images/spacer.gif';
        break;
      case 'FOLDER-01':
      case 'FOLDER-02': {
        // Default to regal
        // let productName;
        // Default to regal - blue color
        let imageName;
        // Default accent color - Silver
        // let accentColor;
        if (!!product.CustomAttributes && product.CustomAttributes.length > 0) {
          const colorValue = getCustomAttribute(product, 'Paper');
          imageName = colorValue ? colorValue.toLowerCase() : imageName;
          // productName = colorValue;
        } else if (product.BaseSku) {
          if (product.BaseSku.indexOf('H') !== -1) {
            imageName = 'hunter';
            // productName = 'Hunter';
          } else if (product.BaseSku.indexOf('R') !== -1) {
            imageName = 'regal';
            // productName = 'Regal';
          } else if (product.BaseSku.indexOf('G') !== -1) {
            imageName = 'charcoal';
            // productName = 'Charcoal';
          } else if (product.BaseSku.indexOf('B') !== -1) {
            imageName = 'bramble';
            // productName = 'Bramble';
          }
        } else {
          // productName = 'Regal';
          imageName = 'regal';
          // accentColor = '';
        }

        if (!!product.CustomAttributes && product.CustomAttributes.length > 0) {
          // const colorValue = getCustomAttribute(product, 'Accent');
          // accentColor = colorValue;
        } else if (product.BaseSku) {
          if (product.BaseSku.indexOf('S') === 0) {
            // accentColor = 'Silver';
          } else {
            // accentColor = 'Black';
          }
        }
        src = `/UI/images/branding/taxfolders/${product.ProductTypeID.toLowerCase()}-${imageName}.png`;
        break;
      }
      case 'FOLDER-03': {
        // Default to regal
        // let prodName;
        // Default to regal - blue color
        let imgName;
        if (!!product.CustomAttributes && product.CustomAttributes.length > 0) {
          const colorValue = getCustomAttribute(product, 'Paper');
          imgName = colorValue ? colorValue.toLowerCase() : imgName;
          // prodName = colorValue;
        } else if (product.BaseSku) {
          if (product.BaseSku.indexOf('G') !== -1) {
            imgName = 'green';
            // prodName = 'Green';
          } else if (product.BaseSku.indexOf('B') !== -1) {
            imgName = 'blue';
            // prodName = 'Blue';
          }
        } else {
          // prodName = 'Green';
          imgName = 'green';
        }
        src = `/UI/images/branding/taxfolders/${product.ProductTypeID.toLowerCase()}-${imgName}.png`;
        break;
      }
      // JIRA - 10178 - To add color specific thumbnail image and description, for two pocket folder product, in Oh, cart and preview page
      case 'FOLDER-04': {
        // Default to regal
        // let proName;
        // Default to regal - blue color
        let imagName;
        if (!!product.CustomAttributes && product.CustomAttributes.length > 0) {
          const colorValue = getCustomAttribute(product, 'Paper');
          imagName = colorValue ? colorValue.toLowerCase() : imagName;
          // proName = colorValue;
        } else if (product.BaseSku) {
          if (product.BaseSku.indexOf('TPH') === 0) {
            imagName = 'hunter';
            // proName = 'Hunter';
          } else if (product.BaseSku.indexOf('TPR') === 0) {
            imagName = 'regal';
            // proName = 'Regal';
          }
        } else {
          // proName = 'Regal';
          imagName = 'regal';
        }
        src = `/UI/ipd/appcommon/images/${imagName}-thumb.png`;
        break;
      }
      case 'PERF-01':
        if (SKUTreatment) {
          src = SKUTreatment.img;
        }
        break;
      case 'TAX-72':
        src = taxNec120;
        optSrc = OptimizedTaxNec120;
        ImageHeight = '140px';
        ImageWidth = '147px';
        break;
      case 'TAX-02':
        src = taxMisc120;
        optSrc = OptimizedTaxMisc120;
        ImageHeight = '140px';
        ImageWidth = '147px';
        break;
      case 'TAX-03':
        src = taxw3120;
        optSrc = OptimizedTaxw3120;
        ImageHeight = '140px';
        ImageWidth = '109px';
        break;
      case 'TAX-04':
        src = tax96120;
        optSrc = OptimizedTax98120;
        ImageHeight = '140px';
        ImageWidth = '109px';
        break;
      case 'QBFORM-01':
        src = '/UI/ipd/appcommon/images/qbform-01-thumb.png';
        break;
      case 'MCHECK-01':
          src='/UI/ipd/appcommon/images/3_to_a_pagemanual_cart.png';
          break;
      case 'LME-01':
      case 'CHECK-04':
      case 'CHECK-15':
      default:
        src = `/UI/ipd/appcommon/images/${product.ProductTypeID.toLowerCase()}.png`;
        break;
    }
  }
  if (
    product.ProductTypeID === 'TAX-72' ||
    product.ProductTypeID === 'TAX-02' ||
    product.ProductTypeID === 'TAX-01' ||
    product.ProductTypeID === 'TAX-03' ||
    product.ProductTypeID === 'TAX-04'
  ) {
    return {
      src: getImageSrc(src),
      optSrc: optSrc ? getImageSrc(optSrc) : null,
      ImageHeight,
      ImageWidth,
    }
  }
  // add environment variable
  return {
    src: getSessionStorage('CDNFallback')?.value? src : (cdn + src),
    optSrc: optSrc ? (getSessionStorage('CDNFallback')?.value? optSrc : (cdn + optSrc))  : null,
    ImageHeight,
    ImageWidth,
  }
  // this.set("imageSrcUrl", ultEnv + src);
  // this.set("imageStyle", style);
};

export const isCheckProduct = (product) => {
  return product.ProductTypeID.indexOf('CHECK') === 0 || product.ProductTypeID === 'MCHECK-01';
};

export const getQuantity = (product) => {
  if (product.ProductTypeID.toUpperCase() === 'QBFORM-01') {
    return '';
  }
  if (product.CustomAttributes && product.CustomAttributes.length) {
    // customattrb is null for Phone orders
    if (product.BaseSku.indexOf('-') > 2) {
      const qty = parseInt(product.BaseSku.substring(product.BaseSku.indexOf('-') + 1), 10);
      if (qty > 0) return qty; // If Qty is not extraced from sku then find basequantity bellow
    }
  }
  const qtyObj =
    product.CustomAttributes &&
    product.CustomAttributes.filter((attribute) => {
      return attribute.Type === 'Quantity';
    });

  if (qtyObj && qtyObj.length) {
    return product.BaseQuantity;
  }
  // const qty = qtyObj && qtyObj.length && qtyObj[0].Name; // In Attributes Name field has qty, do not go on field Name.
  const qty = qtyObj && qtyObj.length > 0 ? qtyObj[0].Name : '1';
  return qty;
};

export const getProductName = (product) => {
  const productId = product.ProductTypeID;
  let productName = product.ProductName;

  if (!!productId && /TAX-0[1-4]|TAX-72/i.test(productId)) {
    const curDate = new Date();
    const fiscalYr = getCurrentFisicalYear(curDate.getFullYear(), curDate.getMonth());
    productName = `${fiscalYr} ${productName}`;
  }
  return productName;
};

export const isdiscountApplied = (cartItem) => {
  const discountedPrice = ~~cartItem.DiscountedPrice;
  const totalListPrice = ~~cartItem.TotalListPrice;
  if (discountedPrice < totalListPrice) return true;
  return false;
};

export const getItemQuantityType = (product, promotionData) => {
  let itemQuantityType;
  if (product.ProductTypeID.indexOf('THERMAL') === 0) {
    itemQuantityType = 'dropDown';
  }

  const state = store.getState();
  const isProductEnvelopeRestricted =
    state.mainReducer.clientConfigs.intuitmarketFlagsisProductEnvelopeRestricted &&
    state.mainReducer.clientConfigs.intuitmarketFlagsisProductEnvelopeRestricted.toLowerCase() ===
      'true';
  if (isProductEnvelopeRestricted && product.ProductTypeID.indexOf('ENV-08') === 0) {
    itemQuantityType = 'textBox';
  }

  // Dont show quantity for QB forms
  else if (product.ProductTypeID.toUpperCase() === 'QBFORM-01') {
    itemQuantityType = '';
  } else if (product.CustomAttributes !== null) {
    if (product.CustomAttributes.length > 0 && product.BaseSku.split('-').length > 1) {
      if (!!promotionData && promotionData.length === 1) {
        itemQuantityType = 'textBox';
      } else if (!!product && product.ProductName.indexOf('Value Pack') > -1) {
        itemQuantityType = 'textBox';
      } else {
        itemQuantityType = 'dropDown';
      }
    } else {
      itemQuantityType = 'textBox';
    }
  } else {
    if (product.BaseSku.split('-').length > 1) {
      itemQuantityType = 'textBox';
    }
  }
  return itemQuantityType;
};

export const getproductPromotiondata = (productId, promotionData) => {
  const result = promotionData.length > 0 ? promotionData.filter((x) => x.PfId === productId) : [];
  return result.length > 0 ? result[0].PromotionDetail : [];
};

export const getCustomAttributeQuantity = (product) => {
  if (!/Value Pack/.test(product.ProductName)) {
    const customAttributesQuantity = product.CustomAttributes.filter((x) => x.Type === 'Quantity');
    if (customAttributesQuantity) {
      return customAttributesQuantity[0] ? customAttributesQuantity[0].Name : '250';
    }
    if (product.BaseQuantity) {
      return product.BaseQuantity;
    }
    return '1';
  }
  return '1';
};

const getMultiformPrices = (basesku, customAttributes, promotionDetailCollection) => {
  const collection = [];
  const parts = customAttributes.filter((x) => x.Type === 'Parts');
  promotionDetailCollection.forEach((model) => {
    const listPrice = parseInt(model.ListPrice);
    const discountedPrice = parseInt(model.DiscountedPrice);
    const quantity = parseInt(model.Quantity);
    const productId = model.ProductID;
    const partsInPromotionDetail = model.Parts;
    let price = discountedPrice < listPrice ? discountedPrice : listPrice;
    price = `$${price / 100}`;
    if (parts) {
      if (productId.indexOf(basesku) === 0) {
        collection.push({
          listPrice,
          price,
          quantity,
          productId,
          label: `${quantity} for ${price}`,
          discountedPrice,
        });
      }
    } else {
      if (
        partsInPromotionDetail.toLowerCase() === parts[0].Name.toLowerCase() &&
        productId.indexOf(basesku) === 0
      ) {
        collection.push({
          listPrice,
          price,
          quantity,
          productId,
          label: `${quantity} for ${price}`,
          discountedPrice,
        });
      }
    }
  });
  return collection;
};

const getReceiptPrices = (promotionDetailCollection) => {
  const collection = [];
  promotionDetailCollection.forEach((model) => {
    const listPrice = parseInt(model.ListPrice);
    const discountedPrice = parseInt(model.DiscountedPrice);
    const quantity = parseInt(model.Quantity);
    const productId = model.ProductID;
    let price = discountedPrice < listPrice ? discountedPrice : listPrice;
    price = `$${price / 100}`;
    collection.push({
      listPrice,
      price,
      quantity,
      productId,
      label: `${quantity} for ${price}`,
      discountedPrice,
    });
  });
  return collection;
};

const getThermalPrices = (basesku, promotionDetailCollection, pfid) => {
  const collection = [];
  promotionDetailCollection.forEach((model) => {
    const listPrice = parseInt(model.ListPrice);
    const discountedPrice = parseInt(model.DiscountedPrice);
    const quantity = parseInt(model.Quantity);
    const productId = model.ProductID;
    let price = discountedPrice < listPrice ? discountedPrice : listPrice;
    price = `$${price / 100}`;
    if (productId === basesku || pfid.indexOf('THERMAL') > -1) {
      if (
        productId.toUpperCase() === 'POSTLS' ||
        productId.toUpperCase() === 'POSJNF4' ||
        productId.toUpperCase() === 'POSJNF' ||
        productId.toUpperCase() === 'POSJF4' ||
        productId.toUpperCase() === 'POSTL' ||
        productId.toUpperCase() === 'POSTHT' ||
        productId.toUpperCase() === 'POSJF'
      )
        collection.push({
          listPrice,
          price,
          quantity,
          productId,
          label: `${quantity} case for ${price}`,
          discountedPrice,
        });
      else
        collection.push({
          listPrice,
          price,
          quantity,
          productId,
          label: `${quantity} rolls for ${price}`,
          discountedPrice,
        });
    }
  });
  return collection;
};

const getCheckPrices = (basesku, customAttributes, promotionDetailCollection, pfid) => {
  const collection = [];
  const parts = customAttributes.find((x) => x.Type === 'Parts')
    ? customAttributes.filter((x) => x.Type === 'Parts')[0].Name
    : '';
  const printerType = customAttributes.find((x) => x.Type === 'Printer Type')
    ? customAttributes.filter((x) => x.Type === 'Printer Type')[0].Name
    : '';
  const checkColor = customAttributes.find((x) => x.Type === 'Style/Color')
    ? customAttributes.filter((x) => x.Type === 'Style/Color')[0].Name
    : '';

  promotionDetailCollection.forEach((model) => {
    const listPrice = parseInt(model.ListPrice);
    const discountedPrice = parseInt(model.DiscountedPrice);
    const quantity = parseInt(model.Quantity);
    const productId = model.ProductID;
    const partsInPromotionDetail = model.Parts;
    const printerTypeInPromotionDetail = model.PrinterType;
    const basic_checks_pfids = ['CHECK-02', 'CHECK-01'];
    let price = discountedPrice < listPrice ? discountedPrice : listPrice;
    price = `$${price / 100}`;
    // For basic checks, if a colour other than blue is selected then 50 quantity should not be shown
    if (basic_checks_pfids.includes(pfid) && checkColor !== 'classic-blue' && quantity === 50) {
      return;
    }
    if (
      partsInPromotionDetail.toLowerCase() === parts.toLowerCase() &&
      printerTypeInPromotionDetail.toLowerCase() === printerType.toLowerCase() &&
      productId.indexOf(basesku) === 0
    ) {
      collection.push({
        listPrice,
        price,
        quantity,
        productId,
        label: `${quantity} for ${price}`,
        discountedPrice,
      });
    }
  });
  return collection;
};

const getTaxFormPrices = (basesku, customAttributes, promotionDetailCollection) => {
  const collection = [];
  const parts = customAttributes.find((x) => x.Type === 'Parts')
    ? customAttributes.filter((x) => x.Type === 'Parts')[0].Name
    : '';
  promotionDetailCollection.forEach((model) => {
    const listPrice = parseInt(model.ListPrice);
    const discountedPrice = parseInt(model.DiscountedPrice);
    const quantity = parseInt(model.Quantity);
    const productId = model.ProductID;
    const partsInPromotionDetail = model.Parts;
    let price = discountedPrice < listPrice ? discountedPrice : listPrice;
    price = `$${price / 100}`;
    if (
      partsInPromotionDetail.toLowerCase() === parts.toLowerCase() &&
      productId.indexOf(basesku) === 0
    ) {
      collection.push({
        listPrice,
        price,
        quantity,
        productId,
        label: `${quantity} for ${price}`,
        discountedPrice,
      });
    }
  });
  return collection;
};

const getDefaultSelectBoxPrices = (basesku, promotionDetailCollection) => {
  const collection = [];
  promotionDetailCollection.forEach((model) => {
    const listPrice = parseInt(model.ListPrice);
    const discountedPrice = parseInt(model.DiscountedPrice);
    const quantity = parseInt(model.Quantity);
    const productId = model.ProductID;
    let price = discountedPrice < listPrice ? discountedPrice : listPrice;
    price = `$${price / 100}`;
    if (productId.indexOf(basesku) === 0) {
      collection.push({
        listPrice,
        price,
        quantity,
        productId,
        label: `${quantity} for ${price}`,
        discountedPrice,
      });
    }
  });
  return collection;
};

export const getDropDownPrices = (product, promotionDetailCollection) => {
  const pfid = product.ProductTypeID;
  const basesku = product.BaseSku.split('-')[0];
  const customAttributes = product.CustomAttributes;
  if (
    pfid.indexOf('ENV') === 0 ||
    pfid.indexOf('LABEL') === 0 ||
    pfid.indexOf('BUNDLE') === 0 ||
    pfid.indexOf('DEP') === 0
  ) {
    return getDefaultSelectBoxPrices(basesku, promotionDetailCollection);
  }
  if (pfid.indexOf('TAX') === 0 || pfid.indexOf('PERF') === 0) {
    return getTaxFormPrices(basesku, customAttributes, promotionDetailCollection);
  }
  if (pfid.indexOf('CHECK') === 0) {
    return getCheckPrices(basesku, customAttributes, promotionDetailCollection, pfid);
  }
  if (pfid.indexOf('THERMAL') === 0) {
    return getThermalPrices(basesku, promotionDetailCollection, pfid);
  }
  if (pfid.indexOf('RECEIPT') === 0) {
    return getReceiptPrices(promotionDetailCollection);
  }
  if (pfid.indexOf('MULTIFORM') === 0 || pfid.indexOf('STATE') === 0) {
    return getMultiformPrices(basesku, customAttributes, promotionDetailCollection);
  }
  return getDefaultSelectBoxPrices(basesku, promotionDetailCollection);
};

export const getPfIds = (cartItemList) => {
  return cartItemList.map((cartItem) => {
    return cartItem.Product.ProductTypeID;
  });
};

export const getValueAddedAttributes = (customAttributes) => {
  const vadd = customAttributes.filter((x) => {
    return x.Value !== '0' && x.Value !== '';
  });
  return vadd;
};

const getStockType = (product) => {
  let stockType = 'Regal';
  if (!!product.CustomAttributes && product.CustomAttributes.length > 0) {
    stockType = product.CustomAttributes.find((x) => {
      return x.Type === 'Paper';
    }).Name;
  } else {
    if (product.productTypeID === 'FOLDER-01' || product.productTypeID === 'FOLDER-02') {
      if (product.BaseSku) {
        if (product.BaseSku.indexOf('H') !== -1) {
          stockType = 'Hunter';
        } else if (product.BaseSku.indexOf('R') !== -1) {
          stockType = 'Regal';
        } else if (product.BaseSku.indexOf('G') !== -1) {
          stockType = 'Charcoal';
        } else if (product.BaseSku.indexOf('B') !== -1) {
          stockType = 'Bramble';
        }
      }
    } else if (product.productTypeID === 'FOLDER-03') {
      if (product.BaseSku) {
        if (product.BaseSku.indexOf('G') !== -1) {
          stockType = 'Green';
        } else if (product.BaseSku.indexOf('B') !== -1) {
          stockType = 'Blue';
        }
      }
    } else if (product.productTypeID === 'FOLDER-04') {
      if (product.BaseSku) {
        if (product.BaseSku.indexOf('TPH') === 0) {
          stockType = 'Hunter';
        } else if (product.BaseSku.indexOf('TPR') === 0) {
          stockType = 'Regal';
        }
      }
    }
  }

  return stockType;
};

const getcolor = (product) => {
  let color;
  if (!!product.CustomAttributes && product.CustomAttributes.length > 0) {
    color = product.CustomAttributes.find((x) => {
      return x.Type === 'Accent' || x.Type === 'Border';
    }).Name;
  } else if (product.BaseSku) {
    if (product.BaseSku.indexOf('S') === 0) {
      color = 'Silver';
    } else {
      color = 'Black';
    }
  }
  return color;
};

export const getProductDescription = (product) => {
  const productDescription = {
    type: '',
    stockType: '',
    color: '',
  };
  const productTypeID = product.ProductTypeID;
  switch (productTypeID) {
    case 'PERF-01': {
      const treatment = getSKUTreatment(product.BaseSku);
      productDescription.type = 'Tax';
      productDescription.description = treatment.desc;
      break;
    }
    case 'FOLDER-01':
    case 'FOLDER-02': {
      productDescription.type = 'StockFolder';
      productDescription.stockType = getStockType(product);
      productDescription.color = getcolor(product);
      break;
    }
    case 'FOLDER-03':
    case 'FOLDER-04': {
      productDescription.type = 'Folder';
      productDescription.stockType = getStockType(product);
      break;
    }
    default:
      break;
  }
  return productDescription;
};

export const isItemEditable = (product) => {
  let itemisEditable = false;
  if (product.ProductTypeID.toUpperCase() === 'QBFORM-01') {
    itemisEditable = false;
  } else if (product.CustomAttributes !== null && product.ImprintId !== 0) {
    itemisEditable = true;
  }
  return itemisEditable;
};

export const handleCheckout = (logged, products, history) => {
  const xSellProducts = products;

  const getXsellCookies = () => {
    const isXSellViewed = getCookie('isXSellViewed');
    const allowGuestCheckout = getCookie('allowGuestCheckout')
      ? getCookie('allowGuestCheckout')
      : '0';
    return { isXSellViewed, allowGuestCheckout };
  };

  const XSellCookie = getXsellCookies();

  const getPFIDsforXsell = () => {
    let cartpfids = [];
    const xSellData = xSellProducts;
    if (xSellData) {
      cartpfids = xSellData.map((x) => {
        return x.PfId.toUpperCase();
      });
      if (cartpfids.length === 3 || (cartpfids.length === 2 && !cartpfids.includes('ENV-08'))) {
        cartpfids.push('ENV-08');
      }
    }
    return cartpfids;
  };
  const CheckoutSignInWidgetRule = (loggedStatus) => {
    return (
      (XSellCookie.isXSellViewed === '1' &&
        loggedStatus === '0' &&
        XSellCookie.allowGuestCheckout === '0') ||
      (loggedStatus === '0' && xSellProducts.length < 3 && XSellCookie.allowGuestCheckout === '0')
    );
  };
  const ShippingNavigationRule = (loggedIn) => {
    return (
      XSellCookie.isXSellViewed === '1' &&
      (loggedIn === '1' || XSellCookie.allowGuestCheckout === '1')
    );
  };
  const InterruptivexsellNavigationRule = () => {
    return xSellProducts.length >= 3;
  };

  if (CheckoutSignInWidgetRule(logged)) {
    return true;
  }
  if (ShippingNavigationRule(logged)) {
    // go to shipping
    history.push('/shipping');
  } else if (InterruptivexsellNavigationRule()) {
    // go to interruptive xsell
    setSessionStorage('XSellPFIds', getPFIDsforXsell());
    history.push('/interruptivexsell');
  } else {
    setCookie('isXSellViewed', '1');
    // go to shipping
    history.push('/shipping');
  }
};

export const getXsellProductName = (xsell_product) => {
  let productName = xsell_product.Name;
  if (/TAX-[0-9][0-9]/i.test(xsell_product.PfId)) {
    const curDate = new Date();
    const fiscalYr = getCurrentFisicalYear(curDate.getFullYear(), curDate.getMonth());
    productName = `${fiscalYr} ${productName}`;
  }
  return productName;
};

export const getCartXsellImageSource = (xsellProduct) => {
  const image = xsellProduct.Image.find((img) => {
    if (/TAX-/i.test(xsellProduct.PfId)) {
      return img.ImageType.toLowerCase() === 'small';
    }
    return img.ImageType.toLowerCase() === 'medium';
  });
  return image ? image.Source : '';
};

export const getXsellImageSource = (intxsellProduct) => {
  const image = intxsellProduct.Image.find((img) => {
    if (/TAX-/i.test(intxsellProduct.PfId)) {
      return img.ImageType.toLowerCase() === 'small';
    }
    return img.ImageType.toLowerCase() === 'large';
  });
  return image ? image.Source : '';
};

export const isQBFormOnlyInCart = (cartItems) => {
  let is_QBFormOnlyInCart = false;
  if (!!cartItems && cartItems.length > 0) {
    is_QBFormOnlyInCart = !(
      cartItems.filter((cartItem) => cartItem.Product.ProductTypeID.toUpperCase() !== 'QBFORM-01')
        .length > 0
    );
  }
  return is_QBFormOnlyInCart;
};

export const isQBFormInCart = (cartItems) => {
  let is_QBFormInCart = false;
  if (!!cartItems && cartItems.length > 0) {
    is_QBFormInCart = !!cartItems.find((item) => {
      return item.Product.ProductTypeID.toUpperCase() === 'QBFORM-01';
    });
  }
  return is_QBFormInCart;
};

export const isMilitaryState = (state) => {
  const militaryStates = ['AA', 'AE', 'AP', 'AS', 'AK', 'HI', 'GU', 'MH', 'MP', 'PR', 'PW', 'VI'];
  return militaryStates.includes(state);
};
export const getShippingSpeedDisplayNames = (code) => {
  const shippingSpeedNames = {
    G: 'Standard',
    S: '2nd Day',
    N: 'Next Day',
    R: 'Standard',
    Q: 'Next Day',
    Z: '2nd Day',
    I: 'USPS Priority',
  };
  return shippingSpeedNames[code];
};

export const getShippingSpeedDate = (date) => {
  if (date) {
    let val = date && date.split('T')[0];
    val = val.split('-');
    return `Arrive no later than ${val[1]}/${val[2]}/${val[0]}`;
  }
};

export const hasCheckProduct = (cart_Items) => {
  let hasCheck = false;
  if (!!cart_Items && cart_Items.length > 0) {
    hasCheck =
      cart_Items.filter(
        (item) =>
          item.Product.ProductTypeID.indexOf('CHECK') === 0 ||
          item.Product.ProductTypeID === 'MCHECK-01' ||
          item.Product.ProductTypeID.indexOf('BUNDLE') === 0,
      ).length > 0;
  }
  return hasCheck;
};

export const formatMonth = (month) => {
  return month < 10 ? `0${month}` : month;
};

export const maskAccnNum = (accn_Num) => {
  const accnNum = accn_Num;
  const length = accnNum ? accnNum.length : 0;
  let maskedNum = accnNum;
  if (!!accnNum && accnNum.length > 0) {
    if (length > 6) {
      maskedNum = new Array(length - 3).join('x') + accnNum.substr(accnNum.length - 4, 4);
    } else if (length > 1) {
      maskedNum =
        new Array(Math.ceil(length / 2 + 1)).join('x') +
        accnNum.substr(accnNum.length - Math.floor(length / 2));
    }
  }
  return maskedNum;
};
